import { Matrix4 as a, Color as i, DynamicDrawUsage as n } from "three";
const s = new a(), c = new i();
function f({
  mesh: t,
  matrices: e,
  colors: r
}) {
  for (let o = 0; o < e.length; o++)
    t.setMatrixAt(o, s.fromArray(e[o])), t.setColorAt(o, c.set(r[o]));
  t.instanceMatrix.needsUpdate = !0, t.instanceColor && (t.instanceColor.needsUpdate = !0, t.instanceColor.usage !== n && t.instanceColor.setUsage(n));
}
export {
  f as updateAbstractSiteInstaMesh
};
//# sourceMappingURL=index3.js.map
